import React from 'react'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../common/integrations'
import { CrossClientQueryDataSource } from '../../../../models/CrossClient'
import { ReactComponent as ZocksIcon } from '../../../../assets/images/ZocksIcon-primary.svg'

type IconSize = 'sm' | 'md'

const sizeMap: Record<IconSize, string> = {
  sm: '0.75rem',
  md: '1rem',
}

interface CrossClientResultSourceIconProps {
  source: CrossClientQueryDataSource
  size?: IconSize
}

export const CrossClientResultDetailSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source, size = 'sm' }) => {
  const dimension = sizeMap[size]

  if (source.type === 'clientProfile' || source.type === 'meeting') {
    return <ZocksIcon width={dimension} height={dimension} />
  }

  return <CrossClientResultSourceIcon source={source} size={size} />
}

export const CrossClientResultSourceIcon: React.FC<CrossClientResultSourceIconProps> = ({ source, size = 'sm' }) => {
  const dimension = sizeMap[size]

  if (source.type === 'integration') {
    return <IntegrationIcon serviceId={source.integrationType as IntegrationServiceId} width={dimension} height={dimension} />
  }

  return null
}
